import React from 'react';

function RecommendedCard({ submission }) {
  return (
    <div style={{
      border: '1px dashed #ccc',
      padding: '4px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '5px',
      background: '#fafafa',
      fontSize: '0.85rem',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }}>
      <a
        href={submission.kofi_url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: '#0056b3',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        <img
          src="https://storage.ko-fi.com/cdn/brandasset/kofi_s_logo_nolabel.png"
          alt="Ko-fi"
          width="24"
          height="24"
          style={{ marginRight: '6px' }}
        />
        {submission.kofi_url}
      </a>
    </div>
  );
}

export default RecommendedCard;




